<template>
  <div class="mt-4">
    <load-and-error :loading="loading" :error="error" :can-retry="canRetry" @retry="refresh()"></load-and-error>

    <div v-if="!loading && !error && part">
        <h1 class="mb-4" v-if="isCreate">
            <router-link :to="{name: 'home'}">
                <i class="fa fa-chevron-left"></i>
            </router-link>

            New Part
        </h1>
        <h1 class="mb-4" v-else>
            <router-link :to="{name: 'part', params: {id: part.id}}">
                <i class="fa fa-chevron-left"></i>
            </router-link>

            Edit: {{part.name}}
        </h1>

        <form @submit.prevent ref="form">
            <div class="form-group">
                <label for="name">Name</label>
                <input type="text" class="form-control" id="name" v-model="part.name" :disabled="saving" required="required" />
            </div>

            <div class="form-group">
                <label for="description">Description</label>
                <input type="text" class="form-control" id="description" v-model="part.description" :disabled="saving" />
            </div>

            <div class="form-group">
                <label for="part_number">Part Number</label>

                <div class="input-group">
                    <input
                        type="text"
                        class="form-control"
                        id="part_number"
                        v-model="part.part_number"
                        :disabled="saving"
                        required="required"
                    />
                    <div class="input-group-append">
                        <barcode-scanner @scanned="part.part_number = $event" />
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="default_location">Default Location</label>
                <select class="form-control" id="default_location" v-model="part.default_location" :disabled="saving">
                    <option v-for="(display, location) in LOCATIONS" :key="location" :value="location">{{display}}</option>
                </select>
            </div>

            <div class="form-group">
                <label for="default_storage">Default Storage</label>
                <input type="text" class="form-control" id="default_storage" v-model="part.default_storage" :disabled="saving" />
            </div>

            <div class="form-group">
                <label for="default_supplier">Default Supplier</label>
                <input type="text" class="form-control" id="default_supplier" v-model="part.default_supplier" :disabled="saving" />
            </div>

            <div class="form-group">
                <label for="minimum">Minimum Count</label>
                <input type="number" class="form-control" id="minimum" min="0" v-model="part.minimum" :disabled="saving" />
            </div>

            <div class="form-group">
                <label for="maximum">Maximum Count</label>
                <input type="number" class="form-control" id="maximum" min="0" v-model="part.maximum" :disabled="saving" />
            </div>
        </form>

        <div class="row mt-4 mb-4">
            <div class="col-12 col-md-4 offset-md-8">
                <button class="btn btn-success w-100" @click="save()" :disabled="saving || !canSave">
                    <i class="fa fa-save mr-2"></i>
                    <span v-if="isCreate">Create</span>
                    <span v-else>Save</span>
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr';

import api from 'ays-shared/api';
import utils from 'ays-shared/utils';
import constants from '@/constants';

export default {
  name: 'EditPart',
  data() {
    return {
      loading: false,
      saving: false,
      error: '',
      part: null,
      canRetry: false,
      LOCATIONS: constants.LOCATIONS,
    };
  },
  mounted() {
    if (this.isCreate) {
      this.part = {
        name: '',
        description: '',
        part_number: '',
        default_location: 'brookville_pa',
        default_storage: '',
        default_supplier: '',
        minimum: 0,
        maximum: null,
      };
    }
    else {
      this.refresh();
    }
  },
  computed: {
    isCreate() {
      return !this.$route.params.id;
    },
    canSave() {
      return (
        !!this.part.part_number &&
                !!this.part.name
      );
    },
  },
  methods: {
    async refresh() {
      this.error = '';
      this.loading = true;
      this.canRetry = true;

      try {
        this.part = await api.inventory.get(this.$route.params.id);
      }
      catch (err) {
        this.part = null;
        this.error = utils.errorMessage(err);
        utils.captureException(err, 'EditPart');
      }
      finally {
        this.loading = false;
      }
    },
    async save() {
      if (this.canSave && this.$refs.form.reportValidity()) {
        this.error = '';
        this.saving = true;
        this.canRetry = false;

        this.part.maximum = this.part.maximum || null;

        try {
          if (this.isCreate) {
            this.part = await api.inventory.create(this.part);
            miniToastr.success('Created Part');
          }
          else {
            await api.inventory.update(this.part.id, this.part);
            miniToastr.success('Saved Part');
          }
          this.$router.push({ name: 'part', params: { id: this.part.id } });
        }
        catch (err) {
          utils.handleNetworkError(err, 'Error saving part', 'EditPart.save');
        }
        finally {
          this.saving = false;
        }
      }
    },
  },
};
</script>
